import { render } from "./FaceGridStatsPage.vue?vue&type=template&id=8a72421a&scoped=true"
import script from "./FaceGridStatsPage.vue?vue&type=script&lang=js"
export * from "./FaceGridStatsPage.vue?vue&type=script&lang=js"

import "./FaceGridStatsPage.vue?vue&type=style&index=0&id=8a72421a&scoped=true&lang=css"

import exportComponent from "/Users/daiabromberg/Downloads/Parsons_Spring/MS2/msdv-thesis/Project/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a72421a"]])

export default __exports__